export default function DottedDivider() {
  return (
    <div
      data-testid="section-divider"
      className="my-2 border-t-2 border-dashed"
      style={{ borderColor: "#D0D0D0" }}
    />
  );
}
